import { atomWithStorage } from "jotai/utils";

export enum LayoutEnum {
  GRID = "grid",
  LIST = "list",
}

// base
export const devkeyJotai = atomWithStorage<string | undefined>("devkey", undefined);
export const layoutJotai = atomWithStorage<LayoutEnum | undefined>("layout", LayoutEnum.GRID);
